export default __webpack_public_path__ + "static/media/blank.c42f3832.jpg";